module.exports = __webpack_public_path__ + "img/insurtech-latam-forum-2023-2.35a91187.png";